module.exports = __webpack_public_path__ + "img/Wasteland_2.055943f0.png";